import React from 'react'
import { THEME } from 'utils'

const InverseHeader = ({ page, title }) => (
  <>
    <div className='pageheader'>
      <h2>{page}</h2>
      <div className='line' />
      <h1>{title}</h1>
    </div>
    <style jsx>{`
      .pageheader {
        padding: 0.8rem 1.2rem 0.5rem;
        overflow: hidden;
        width: 100%;
        background-color: #f5f5f5;
      }
      .pageheader h1 {
        font-size: 0.73rem;
        margin: 0.25rem 0;
        line-height: 25px;
        text-transform: uppercase;
      }
      .line {
        width: 100%;
        height: 3px;
        background: #eb3e3f;
      }
      .pageheader h2 {
        font-size: 0.5rem;
        color: #eb3e3f;
        margin-bottom: 0.35rem;
        text-transform: uppercase;
      }
      @media (min-width: 370px) {
        .pageheader h1 {
          font-size: 0.875rem;
          line-height: 30px;
        }
        .pageheader h2 {
          font-size: 0.6rem;
        }
      }
      @media (min-width: 400px) {
        .pageheader {
          padding: 0.8rem 1.1rem 0.5rem;
        }
        .pageheader h1 {
          font-size: 0.968rem;
        }
        .pageheader h2 {
          font-size: 0.65rem;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
        .pageheader {
          padding: 1.5rem 1.5rem 1rem;
        }
        .pageheader h1 {
          // font-size: 1.425rem;
          font-size: 3.8vw;
          line-height: 40px;
        }
        .pageheader h2 {
          font-size: 0.8rem;
          margin-bottom: 0.5rem;
        }
      }
      @media (min-width: 700px) {
        .pageheader h2 {
          font-size: 0.85rem;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
        .pageheader {
          padding: 2rem 3.75rem 1.5rem;
        }
        .pageheader h1 {
          font-size: 2.35vw;
          line-height: 1.44;
          max-width: 905px;
          // font-size: 1.4rem;
        }
        .pageheader h2 {
          font-size: 1.5vw;
          margin-bottom: 0.25rem;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
        .pageheader {
          padding: 2rem 4.4rem 1.5rem;
        }
        .pageheader h2 {
          font-size: 1.3vw;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
        .pageheader {
          padding: 2rem 4.5rem 1.5rem;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
        .pageheader h1 {
          font-size: 1.8rem;
        }
        .pageheader h2 {
          font-size: 0.95rem;
        }
      }
    `}</style>
  </>
)

export default InverseHeader
